import {
  BoardColumnPinButton,
  ButtonGroup,
  ButtonIcon,
  Flex,
  Typography,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  IPlanningDraftSprint,
  PlanningDraftSprintDeleteButton,
  PlanningDraftSprintHeaderMenu,
} from 'features/planning';
import { PlanningDraftSprintHeaderStartButton } from 'features/planning/components/Board/DraftSprint/Header/StartButton';

type TPlanningDraftSprintHeaderViewer = {
  sprint: IPlanningDraftSprint;
  onEdit: () => void;
};

export const PlanningDraftSprintHeaderViewer = ({
  sprint,
  onEdit,
}: TPlanningDraftSprintHeaderViewer) => {
  return (
    <Flex
      data-testid="planning-draft-sprint-board-header"
      alignItems="center"
      flexDirection="column"
      width="100%"
    >
      <Flex
        justifyContent="space-between"
        width="100%"
        p="8px 16px"
        alignItems="center"
      >
        <Flex gap="0.5rem" alignItems="center">
          <Typography color="black" fontWeight="semibold" type="meta">
            {sprint.title}
          </Typography>
          <ButtonIcon
            aria-label="edit"
            data-testid="edit-btn"
            variant="ghost"
            onClick={onEdit}
            rounded="full"
          >
            <Icon name={iconNames.pen} width="14px" height="14px" />
          </ButtonIcon>
        </Flex>
        <ButtonGroup gap="0.5rem" size="sm">
          <PlanningDraftSprintHeaderStartButton
            sprintId={sprint.sprintId}
            sprintChallengesCount={sprint.challengesCount}
            sprintTitle={sprint.title}
          />
          <BoardColumnPinButton columnId={sprint.sprintId} />
          <PlanningDraftSprintDeleteButton sprint={sprint} />
          <PlanningDraftSprintHeaderMenu sprint={sprint} />
        </ButtonGroup>
      </Flex>
    </Flex>
  );
};
